/*
 * ohp-acq-optin.js — ACQ homepage inline email opt-in (sections/ohp-acq-optin.liquid).
 * Submitting subscribes the email to a Klaviyo list via the client-subscribe endpoint
 * (company HzVMMY), then reveals the section's success state. List id comes from the
 * form's data-list-id (schema setting; default UdmbFk). Mirrors the working RET
 * Subscribe & Save waitlist wiring in ohp-ret.js. Fire-and-forget / optimistic:
 * the success state shows immediately, matching the low-friction opt-in UX.
 */
(function () {
  function subscribe(listId, email, firstName) {
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=HzVMMY', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: firstName || undefined,
                    properties: { acq_homepage_optin: true }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).catch(function () {});
    } catch (e) {
      /* ignore — opt-in is optimistic */
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ohp-optin-form]'), function (form) {
    if (form.__ohpOptinBound) return;
    form.__ohpOptinBound = true;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('[name="email"]');
      var nameInput = form.querySelector('[name="first_name"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var firstName = nameInput ? nameInput.value.trim() : '';

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (emailInput && emailInput.reportValidity) emailInput.reportValidity();
        return;
      }

      var listId = form.getAttribute('data-list-id');

      // Optimistic: swap the form for the success state, then fire the subscribe.
      var scope = form.closest('.ohp-acq-optin__inner') || form.parentElement || document;
      var formState = scope.querySelector('.ohp-acq-optin__form-state');
      var success = scope.querySelector('[data-ohp-optin-success]');
      if (formState) formState.style.display = 'none';
      if (success) {
        success.style.display = 'block';
        success.setAttribute('aria-hidden', 'false');
      }

      if (listId) subscribe(listId, email, firstName);
    });
  });
})();
